import {FC, useState} from 'react';
import classNames from 'classnames';

import './Wrapper.sass';


export const Wrapper: FC<Partial<IWrapperProps>> = ({
    selected = false,
    expandable = true,
    onClick,
    children,
}) => {
    const [expanded, setExpanded] = useState<boolean>(false);


    function handleClick() {
        if (expandable) {
            setExpanded(!expanded);
        }
        if (onClick) {
            onClick();
        }
    }


    return (
        <div
            className={classNames('mvc-chat-wrapper', {expanded, selected})}
            onClick={handleClick}
            children={children}/>
    );
};


interface IWrapperProps {
    selected: boolean;
    expandable: boolean;
    onClick: () => void;
}